import { Language } from '@shopee-user/global';
import { getUserLanguage } from '@shopee-user/platform';

// from transify https://transify.sea.com/resources/1431
// key: `title_crash`
const TITLE_CRASH_DICT: Partial<Record<Language, string>> = {
  [Language.en]:
    "It's us, not you. Please try to refresh the page to solve the problem",
  [Language.id]: 'Terjadi error pada sistem kami. Silakan muat ulang halaman.',
  [Language.ms]:
    'Ini kami, bukan anda. Sila muat semula halaman untuk menyelesaikan masalah ini.',
  [Language.th]: 'โปรดลองรีเฟรชหน้าอีกครั้ง',
  [Language.zh_Hans]: '抱歉！请尝试刷新页面',
  [Language.vi]: 'Không thành công. Thử tải lại trang.',
};

const TITLE_RETRY_DICT: Partial<Record<Language, string>> = {
  [Language.en]: 'Retry',
  [Language.id]: 'Coba lagi',
  [Language.ms]: 'Cuba semula',
  [Language.th]: 'ลองอีกครั้ง',
  [Language.zh_Hans]: '重试',
  [Language.vi]: 'Thử lại',
};

export const TITLE_CRASH_TEXT =
  TITLE_CRASH_DICT[getUserLanguage()] || TITLE_CRASH_DICT[Language.en] || '';

export const TITLE_RETRY_TEXT =
  TITLE_RETRY_DICT[getUserLanguage()] || TITLE_RETRY_DICT[Language.en] || '';
